import { Dropdown } from '@creditsights/styleguide-web';
import { DropdownProps } from '@creditsights/styleguide-web/components/Dropdown/Dropdown.types';
import { ReactElement, useEffect, useMemo } from 'react';
import { DropdownItemProps } from 'semantic-ui-react';
import useFetchWidgetMetrics from '../../../../hooks/riskProducts/dashboard/useFetchWidgetMetrics';
import { WIDGET_ID } from '../../../../services/dtos/riskProducts/widgetMetric.dto';

interface MetricDropdownProps extends DropdownProps {
  widgetId: WIDGET_ID;
}

const MetricsDropdown = ({ widgetId, value, onOptionSelect, ...rest }: MetricDropdownProps): ReactElement => {
  const { data } = useFetchWidgetMetrics();

  useEffect(() => {
    onOptionSelect(data![widgetId][0].id);
  }, []);

  const availableMetrics: DropdownItemProps[] = useMemo(() => {
    return data![widgetId].map((metric) => ({
      text: metric.name,
      value: metric.id,
      key: metric.id,
    }));
  }, [data, widgetId]);

  return (
    <Dropdown
      value={value}
      onOptionSelect={(value) => {
        onOptionSelect(value as string);
      }}
      small
      secondary
      options={availableMetrics}
      withCheckmarks
      withCaretIcon
      dataTestId="metric-select"
      {...rest}
    />
  );
};

export default MetricsDropdown;
